import { useEffect, useState } from "react";
import FolderIcon from "@mui/icons-material/Folder";
import { TextField, MenuItem } from "@mui/material";
import AddItemDialog from "../../Dialogs/AddItemDialog";

const MoveItemDialog = ({
  open,
  paths,
  pathString,
  handleCancel,
  moveExam,
}: {
  open: boolean;
  paths: {} | null;
  pathString: string;
  handleCancel: () => void;
  moveExam: (targetPath: string) => void;
}) => {
  const currentPath = !pathString || pathString === "" ? "/" : pathString;
  const [targetPath, setTargetPath] = useState(currentPath);
  const [keys, setKeys] = useState<string[] | null>(null);

  useEffect(() => {
    if (paths) {
      const keys = Object.keys(paths).sort();
      setKeys(keys);
    }
  }, [paths]);

  useEffect(() => {
    if (paths && open) {
      const filteredKeys = Object.keys(paths)
        .filter((key) => key !== currentPath)
        .sort();

      setKeys(filteredKeys);
      setTargetPath(filteredKeys[0]);
    }
  }, [paths, open]);

  return (
    <AddItemDialog
      open={open}
      handleCancel={handleCancel}
      handleConfirm={() => moveExam(targetPath)}
      title={"Prüfung verschieben"}
      description={"Wohin soll die Prüfung verschoben werden?"}
      confirmText={"Verschieben"}
      confirmAllowed={targetPath !== currentPath}
    >
      <TextField
        margin="dense"
        id="targetPath"
        label="Zielpfad"
        color="primary"
        select
        error={currentPath === targetPath}
        style={{ width: "100%" }}
        value={targetPath}
        onChange={(e) => setTargetPath(e.target.value)}
        onKeyDown={(e) => {
          if (e.code === "Enter" && targetPath !== currentPath) moveExam(targetPath);
        }}
      >
        {keys &&
          keys.map((k) => (
            <MenuItem key={k} value={k}>
              <FolderIcon style={{ marginBottom: "-2px", marginRight: "10px" }} />
              {k}
            </MenuItem>
          ))}
      </TextField>
    </AddItemDialog>
  );
};

export default MoveItemDialog;
